export const initializePayments = () => {
    // eslint-disable-next-line no-empty
    if (process.env.REACT_APP_ENV === 'production') {
        // eslint-disable-next-line no-empty
    } else {
    }
}

export const payment = {
    mode: {
        card: 'card',
        paypal: 'paypal',
        venmo: 'venmo',
    },
    getPaymentMode: id => {
        if (id === 'paypal') return payment.mode.paypal
        if (id === 'venmo') return payment.mode.venmo
        return payment.mode.card
    },
}
